import { ca } from '@cian/analytics';

export const trackNewDreamClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label: 'DreamNewlyOnb',
  });
};

export const trackHomeProfitClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'MyHome',
    action: 'Click',
    label: 'MakeMoneyOnb',
  });
};
